import { useParams } from "react-router-dom";
import { AmountFormatter } from "../helpers/AmountFormatter";
import { paymentApi } from "../store/services/PaymentService";
import { useSelector } from "react-redux";

export default function PriceRow() {

    const { id } = useParams();
    const { data } = useSelector(paymentApi.endpoints.getPayment.select(id));
    let customColor = data?.customColor;
    let customSize = data?.customPriceRowSize;

    return (
        <>
            <div className={`h-24 py-5 flex items-center justify-center px-8 ${customColor ? "" : "bg-skin-bgPriceRow"}`} 
                style={{
                        ...(customColor && { backgroundColor: customColor }),
                        ...(customSize && { height: customSize + "px" })
                    }}>
                <p style = {{fontSize: customSize && parseInt(customSize) < 96 ? String((customSize /2)+"px") : "39px"}} className={`${customSize ? "" : "text-xl2"} font-bold leading-snug text-skin-priceRow`}>
                    {AmountFormatter(data?.payment?.amount, data?.payment?.currency)}
                </p>
            </div>
        </>
    )
}